import { render, staticRenderFns } from "./MoreInfoButton.vue?vue&type=template&id=7bdae4bc&"
import script from "./MoreInfoButton.vue?vue&type=script&lang=ts&"
export * from "./MoreInfoButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports